<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>

<script>
import Storage from '@/utils/storage'
export default {
  name: 'App',
  watch: {
    '$i18n.locale': 'i18nHandle'
  },
  created() {
    this.i18nHandle(this.$i18n.locale)
  },
  methods: {
    i18nHandle(val, oldVal) {
      Storage.set('lang', val)
      document.querySelector('html').setAttribute('lang', val)
    }
  }
}
</script>
<style lang="scss">
@import "~@/assets/styles/index.scss";
</style>
